export { default as TableColumn } from './TableColumn'
export { default as OperColumn } from './OperColumn'


// WEBPACK FOOTER //
// ./src/components/publicTable/column/index.js